// Version de l'application (26/10/2026) : identifiée par le fichier principal
// compilé (main.<empreinte>.js). Un onglet ouvert avant une mise en ligne
// garde l'ancien code en mémoire tant qu'il n'est pas rechargé ; on compare
// donc son fichier principal à celui de la page servie actuellement.
const MAIN_RE = /\/static\/js\/main\.([0-9a-f]+)\.js/;

/** Empreinte du fichier principal cité dans un HTML ou une URL, sinon null. */
export function mainScriptOf(text) {
  const m = String(text || "").match(MAIN_RE);
  return m ? m[1] : null;
}

/** Empreinte du fichier principal chargé par cet onglet (null en développement). */
export function currentMainScript(doc = document) {
  for (const s of Array.from(doc.scripts || [])) {
    const h = mainScriptOf(s.src);
    if (h) return h;
  }
  return null;
}

/** true si la page servie cite un autre fichier principal que celui de l'onglet. */
export async function isOutdated(mine, fetchImpl = fetch) {
  if (!mine) return false;
  try {
    const r = await fetchImpl("/index.html", { cache: "no-store" });
    if (!r.ok) return false;
    const latest = mainScriptOf(await r.text());
    return !!latest && latest !== mine;
  } catch {
    return false; // hors ligne : on réessaiera
  }
}
